import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../features/auth/hooks/useAuth'
import { BrandLogo } from '../shared/components/brand/BrandLogo'

/**
 * AuthLayout component
 * - Shared shell for login / request-access / portal sign-in / setup-password
 * - Sage brand band over a cream form card; full-bleed on mobile, floating
 *   rounded card on desktop
 * - Band colours are literal on purpose: the brand band looks the same in
 *   every theme
 */
export const AuthLayout = () => {
  const { passwordRecovery } = useAuth()
  const location = useLocation()

  // A recovery link redirects to whatever Supabase has as its Site URL, which
  // is usually not /reset-password — it lands here, on the login form, while
  // detectSessionInUrl quietly consumes the token. Without this the link
  // looks like it did nothing at all.
  if (passwordRecovery && location.pathname !== '/reset-password') {
    return <Navigate to="/reset-password" replace />
  }

  return (
    <div className="flex min-h-screen flex-col items-center bg-background md:justify-center md:py-12">
      <div className="w-full max-w-md overflow-hidden bg-card shadow-lg high-contrast:border-2 max-md:min-h-screen md:rounded-[2rem]">
        {/* Sage band with soft translucent circles */}
        <div className="relative h-[220px] overflow-hidden" style={{ backgroundColor: '#7a8a5e' }}>
          <div
            className="absolute -left-10 -top-16 h-52 w-52 rounded-full"
            style={{ backgroundColor: 'rgba(249, 244, 237, 0.12)' }}
          />
          <div
            className="absolute -bottom-20 right-2 h-44 w-44 rounded-full"
            style={{ backgroundColor: 'rgba(249, 244, 237, 0.10)' }}
          />
          <h1 className="absolute bottom-6 left-6" style={{ color: '#f5ead8' }}>
            <BrandLogo className="h-12 w-auto" />
          </h1>
        </div>

        <div className="p-6 md:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
